import styled, { css, keyframes } from 'styled-components';
import { normaliseColor } from '@movember/mo-gel/utils/colors';

export const overlayKeyFrames = (props) => {
  const { direction } = props;
  if (direction === 'slide-down') {
    return keyframes`
    0% { transform: scaleY(0.2); }
    100% { transform: scaleY(1); }
  `;
  }
  return keyframes`
      0% { transform: scaleX(0.2); }
      100% { transform: scaleX(1); }
    `;
};

const getOverlayPosition = (props) => {
  const { position, direction, type } = props;
  if (direction === 'slide-down') {
    return css`
      top: ${type === 'fullScreen' ? position.height : position.y + position.height}px;
      left: ${type === 'fullScreen' ? '0' : '5%'};
      width: ${type === 'fullScreen' ? '100%' : '90%'};
      height: ${type === 'fullScreen' ? '100%' : 'auto'};
      transform-origin: top;
    `;
  }
  return css`
    top: ${position.y}px;
    left: ${position.x + position.width}px;
    transform-origin: left;
  `;
};

export const StyledPanel = styled.div`
  ${(props) => getOverlayPosition(props)}
  animation: ${(props) => overlayKeyFrames(props)} 0.2s forwards;
  position: ${(props) => (props.type === 'fullScreen' ? 'absolute' : 'fixed')};
  background: ${(props) => (props.type === 'fullScreen' ? '#f1efe9' : props.theme.colors.white)};
  ${(props) => props.type === 'fullScreen' && 'opacity: 0.8'};
  border: solid 1px ${(props) => props.theme.colors.brandThemeLight100}
  color: ${(props) => {
    return normaliseColor(props.theme.typography.defaultColors, props.theme) || props.theme.colors.primaryFont;
  }};
`;
